import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SourceAccountService } from '../../services/sourceAccountService.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserService } from '../../services/user.service';
@Component({
  selector: 'app-add-user-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinnerModule,
],
  templateUrl: './add-user-modal.component.html',
  styleUrl: './add-user-modal.component.scss'
})
export class AddUserModalComponent {
  public addUserForm: FormGroup;
  public roles = ['Admin', 'Contributor'];
  public companiesList: string[] = [];
  public isSaving: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddUserModalComponent>,
    public sourceAccountService: SourceAccountService,
    public userService: UserService,
  ) {
    this.getCompanies();
    this.addUserForm = this.fb.group({
      name: ['', [Validators.required, this.noWhitespaceValidator()]],
      email: ['', [Validators.required, this.customEmailValidator]],
      role: ['', Validators.required],
      companies: [[], Validators.required],
    });
  }

  getCompanies() {
    this.sourceAccountService.getCompanies().subscribe({
      next: (data: string[]) => {
        this.companiesList = data;
        this.companiesList.push('fh_aut.');
      },
      error: () => {
        this.snackBar.open('Error fetching companies', 'Close', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.addUserForm.valid) {
      this.isSaving = true;
      const newUser = {
        ...this.addUserForm.value,
      }
      this.userService.createUser(newUser).subscribe({
        next: () => {
          this.snackBar.open('User created successfully', 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });

          this.dialogRef.close(true);
        },
        error: () => {
          this.snackBar.open('Creation of user failed. Please try again.', 'Close', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
        },
        complete: () => {
          this.isSaving = false;
        }
      });
    }
  }

  noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value ?? '').trim().length === 0;
    return isWhitespace ? { 'whitespace': true } : null;
    };
  }

  customEmailValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.value;
    if (!email) {
      return null;
    }
    const emailRegex = /^[a-z][a-z0-9._%+-]*@[a-z0-9.-]+\.[a-z]{2,}$/;
    return emailRegex.test(email) ? null : { customEmail: true };
  }
}

